import { Box, CircularProgress, Modal, Typography } from "@mui/material";
import BarcodeReader from "react-barcode-reader";
import useGetDevice from "../../../product/hooks/useGetDevice";
import { FilterProduct, getInventoryData, getProductDetails } from "../../../../../config/Services";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import { useEffect, useState } from "react";
import { ProductDetailInfo } from "./components/productDetailInfo/index";
import Spinner from "../../../../../components/Spinner";
import SearchIcon from "@mui/icons-material/Search";
import SoftBox from "../../../../../components/SoftBox";
import ClearIcon from "@mui/icons-material/Clear";
import "./index.css";
import { SearchResult } from "./components/searchResult";
import { getSearchOpen } from "../../../product/all-products/redux/Reducers/paginationReducer";
import { useSelector } from "react-redux";
import { customEventTrigger } from "../../../../../analytics";
import CartItemDrawer from "../../../product/all-products/components/cartItemTable/Drawer/CartItemDrawer/CartItemDrawer";

export const ProductDetailsPage = ({ openProductDetailModal, handleProductDetailsClose }) => {
  const isMobile = useGetDevice();
  const [datRows, setTableRows] = useState(null);
  const [priceInfo, setPriceInfo] = useState(null);
  const showSnackbar = useSnackbar();
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const [packagingType, setPackagingType] = useState(null);
  const [loader, setLoader] = useState(null);
  const [sText, setStext] = useState("");
  const [notFound, setNotFound] = useState(null);
  const [list, setList] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const spDetails = useSelector(getSearchOpen);

  /* CartItemDrawer state — opened when user clicks a search-result product body */
  const [cidOpen, setCidOpen] = useState(false);
  const [cidData, setCidData] = useState(null);

  const handleProductBodyClick = (productData) => {
    setCidData(productData);
    setCidOpen(true);
  };

  const style = {
    position: isMobile ? "static" : "absolute",
    top: "50%",
    left: "50%",
    transform: isMobile ? "none" : "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "10px",
    border: "1px solid #999999",
    boxShadow: 24,
    p: 4,
    maxHeight: "100%",
    overflowY: "auto",
  };

  const handleGetProductDetail = (gtin, locId) => {
    setLoader(true);
    setIsSearch(false);
    getProductDetails(gtin, locId)
      .then((response) => {
        setTableRows(response?.data?.data);
        setPackagingType(
          response?.data?.data?.packaging_type
            ? response?.data?.data?.packaging_type.toLowerCase().replace(/\s/g, "")
            : ""
        );
        getInventoryData(locId, gtin)
          .then(async (res) => {
            if (res?.data?.data?.es === 1) {
              setNotFound(true);
            } else {
              setPriceInfo(res?.data?.data?.data);
            }
            setLoader(false);
          })
          .catch((error) => {
            setLoader(false);
            showSnackbar("Something went wrong, Please try again", "error");
          });
      })
      .catch((error) => {
        setLoader(false);
        showSnackbar("Something went wrong, Please try again", "error");
      });
  };

  const searchClear = () => {
    setStext("");
    setTableRows(null);
    setPriceInfo(null);
    setNotFound(false);
    setList(null);
    setIsSearch(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.altKey && event.key == "r" && openProductDetailModal) {
        searchClear();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [openProductDetailModal]);

  const renderEndIcon = () => {
    return <ClearIcon className="clear-icon" onClick={searchClear} />;
  };

  const clickPress = (value) => {
    setIsSearch(true);
    setStext(value);
    const suggestionPayload = {
      page: "1",
      pageSize: "100",
      query: value,
      storeLocations: [locId],
      storeIds: [orgId],
      flattenResponse: true,
    };
    setLoader(true);
    FilterProduct(suggestionPayload)
      .then((res) => {
        setLoader(false);
        if (res?.data?.data?.data?.totalRecords === "0") {
          setList([]);
          setNotFound(true);
        } else {
          setList(res?.data?.data?.data?.data);
        }
      })
      .catch((err) => {
        setLoader(false);
        showSnackbar(err.message || err.data.response.message, "error");
      });
  };

  return (
    <>
      <Modal
        open={spDetails}
        onClose={handleProductDetailsClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-product-details"
      >
        <Box sx={style} p={2} className="modal-product-details">
          {openProductDetailModal ? (
            <BarcodeReader
              onScan={(sc) => {
                handleGetProductDetail(sc, locId);
              }}
              onError={(err, msg) => {
                showSnackbar("Something went wrong. Please try again", "error");
              }}
              avgTimeByChar={120}
            />
          ) : null}
          <Box>
            <Box
              sx={{
                display: "flex",
              }}
              mb={2}
            >
              <div className="wrapper-input-box">
                <SearchIcon className="search-icon" />
                <input
                  id="search-input"
                  className="search-input"
                  placeholder="Search with barcode or Product name"
                  onChange={(e) => {
                    clickPress(e.target.value),
                      customEventTrigger("pos_search_with_barcode", {
                        search_value: e.target.value,
                      });
                  }}
                  value={sText}
                  type="text"
                />
                {renderEndIcon()}
              </div>
            </Box>
            {loader ? (
              <SoftBox
                sx={{
                  height: "525px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "600px",
                }}
              >
                <Spinner />
              </SoftBox>
            ) : (
              <>
                {!isSearch ? (
                  <ProductDetailInfo
                    datRows={datRows}
                    priceInfo={priceInfo}
                    packagingType={packagingType}
                    notFound={notFound}
                  />
                ) : (
                  <SearchResult
                    list={list}
                    handleGetProductDetail={handleGetProductDetail}
                    locId={locId}
                    onProductClick={handleProductBodyClick}
                  />
                )}
              </>
            )}
          </Box>
        </Box>
      </Modal>

      {/* CartItemDrawer — opened by clicking a product row in search results */}
      <CartItemDrawer
        cartItemModalOpen={cidOpen}
        setCartItemModalOpen={setCidOpen}
        cartItemData={cidData}
      />
    </>
  );
};
